import React, { useEffect, useMemo, useState } from 'react';
import api from '../../../../services/api';
import { encodePathSegments } from '../../../../../utils/media-url';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardActionArea,
    CardContent,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    OutlinedInput,
    TextField,
    Typography,
    useTheme
} from '@mui/material';

import {
    IconSearch,
    IconPlus,
    IconUser,
    IconEdit,
    IconTrash,
    IconMail,
    IconShield,
    IconDeviceFloppy,
    IconArrowLeft,
    IconX,
    IconUsers
} from '@tabler/icons';

import { motion } from 'framer-motion';
import { useHistory, useParams } from 'react-router-dom';

const BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000/api/';

const MotionCard = motion(Card);

const ROLE_OPTIONS = [
    {
        value: 'admin',
        label: 'Administrador'
    },
    {
        value: 'manager',
        label: 'Gerente'
    },
    {
        value: 'attendant',
        label: 'Atendente'
    }
];

const SystemUsers = () => {
    const theme = useTheme();

    const history = useHistory();

    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState('');

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    const [avatar, setAvatar] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState('');

    const [openModal, setOpenModal] = useState(false);

    const [editingUser, setEditingUser] = useState(null);

    const [appId, setAppId] = useState(null);

    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        email: '',
        role: 'attendant',
        avatar: '',
        username: '',
        password: ''
    });

    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            setAppId(response.data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    // só lista quando tiver appId
    useEffect(() => {
        if (!appId) return;
        loadUsers();
    }, [appId]);

    useEffect(() => {
        if (!form.first_name) return;
        if (!form.last_name) return;

        const fn = form.first_name;
        const ln = form.last_name;
        console.log(`fn: ${fn}`);
        console.log(`ln: ${ln}`);

        if (fn && ln) {
            const username = `${fn.toLowerCase()}.${ln.toLowerCase()}`;
            console.log(`username: ${username}`);

            setForm({
                ...form,
                username: username
            });
        }
    }, [form.first_name, form.last_name]);

    const loadUsers = async () => {
        setLoading(true);

        try {
            const response = await api.get('users/');

            // setUsers(response.data?.users || []);
            setUsers(response.data?.users || response.data);
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao carregar usuários.'
            });
        } finally {
            setLoading(false);
        }
    };

    const filteredUsers = useMemo(() => {
        if (!search.trim()) {
            return users;
        }

        const term = search.toLowerCase();

        return users.filter(
            (user) =>
                user.first_name?.toLowerCase().includes(term) ||
                user.last_name?.toLowerCase().includes(term) ||
                user.email?.toLowerCase().includes(term)
        );
    }, [search, users]);

    const handleOpenCreate = () => {
        removeImage();

        setEditingUser(null);
        setStatus({ type: '', message: '' });

        setForm({
            first_name: '',
            last_name: '',
            email: '',
            role: 'attendant',
            username: '',
            password: ''
        });

        setOpenModal(true);
    };

    const handleOpenEdit = (user) => {
        setEditingUser(user);
        setStatus({ type: '', message: '' });

        setForm({
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            email: user.email || '',
            role: user.role || 'attendant',
            avatar: user.avatar_img || '',
            username: '',
            password: ''
        });

        // setAvatar(user.avatar_img);
        // setAvatarPreview(user.avatar_img);

        setOpenModal(true);
        removeImage();
    };

    const handleResetPassword = async () => {
        if (!editingUser?.email) return;

        const confirmReset = window.confirm(`Enviar e-mail de redefinição de senha para ${editingUser.email}?`);

        if (!confirmReset) return;

        try {
            await api.post('password-reset/', { email: editingUser.email });

            setStatus({
                type: 'success',
                message: `E-mail de redefinição de senha enviado para ${editingUser.email}.`
            });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao enviar e-mail de redefinição de senha.'
            });
        }
    };

    const handleSave = async () => {
        try {
            console.log(`handleSave - entrou`);
            console.log(`handleSave - form:${JSON.stringify(form)}`);
            console.log(`handleSave - editingUser:${JSON.stringify(editingUser)}`);

            let response;

            if (editingUser) {
                console.log('editingUser');
                response = await api.patch(`user/edit/${editingUser.id}/`, form);

                // upload avatar
                if (avatar) {
                    console.log(`avatarr: ${avatar}`);
                    const formData = new FormData();

                    formData.append('imagem', avatar);

                    const respAvatar = await api.patch(`user/edit/${editingUser.id}/`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    console.log(`respAvatar: ${JSON.stringify(respAvatar)}`);
                }

                setStatus({
                    type: 'success',
                    message: 'Usuário atualizado com sucesso.'
                });
            } else {
                const fn = form.first_name;
                const ln = form.last_name;
                console.log(`fn: ${fn}`);
                console.log(`ln: ${ln}`);

                if (fn && ln) {
                    const username = `${fn.toLowerCase()}.${ln.toLowerCase()}`;
                    console.log(`username: ${username}`);

                    setForm({
                        ...form,
                        username: username
                    });
                }

                const { password: _password, ...formSemSenha } = form;

                response = await api.post('users/create/', formSemSenha);

                console.log(`create_user - response: ${JSON.stringify(response.data)}`);

                // upload avatar
                if (avatar) {
                    console.log(`avatarr: ${avatar}`);
                    const formData = new FormData();

                    formData.append('imagem', avatar);

                    const respAvatar = await api.patch(`user/edit/${response.data.id}/`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    console.log(`respAvatar: ${JSON.stringify(respAvatar)}`);
                }

                setStatus({
                    type: 'success',
                    message: 'Usuário criado com sucesso. Um e-mail foi enviado para que ele defina sua senha.'
                });
            }

            setOpenModal(false);

            removeImage();

            loadUsers();
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                // O backend manda o motivo em `error` (ex: "Email já registrado",
                // ver `user_create`/`users/views.py`) - sem ler essa chave, o
                // usuário só via um "Erro ao salvar usuário." genérico, sem
                // nenhuma pista do que precisava corrigir pra tentar de novo.
                message: error.response?.data?.error || error.response?.data?.detail || 'Erro ao salvar usuário.'
            });
        }
    };

    const handleDelete = async (userId) => {
        const confirmDelete = window.confirm('Deseja realmente excluir este usuário?');

        if (!confirmDelete) {
            return;
        }

        try {
            await api.delete(`user/edit/${userId}/`);

            setUsers((prev) => prev.filter((u) => u.id !== userId));

            setStatus({
                type: 'success',
                message: 'Usuário excluído com sucesso.'
            });
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao excluir usuário.'
            });
        }
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];

        if (!file) return;
        console.log(`handleImageUpload - file: ${file}`);

        setAvatar(file);
        setAvatarPreview(URL.createObjectURL(file));
    };

    const removeImage = () => {
        setAvatar(null);
        setAvatarPreview('');
    };

    // const getAvatarUrl = (path) => {
    //     if (!path) return '';

    //     return `${BACKEND_SERVER}users/media/${path}`;
    // };

    const getAvatarUrl = (path) => {
        if (!path) return '';

        return `${BACKEND_SERVER}v1/apps/${appId}/media/${encodePathSegments(path)}`;
    };

    return (
        <Box>
            {/* HERO */}
            <Button
                variant="outlined"
                startIcon={<IconArrowLeft size={18} />}
                onClick={() => history.goBack()}
                sx={{
                    borderRadius: '12px',
                    textTransform: 'none'
                }}
            >
                Voltar
            </Button>

            <Box
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '28px',
                    marginTop: 2,
                    p: {
                        xs: 3,
                        md: 5
                    },
                    mb: 4,
                    background:
                        theme.palette.mode === 'dark'
                            ? 'linear-gradient(135deg,#111827 0%,#1e293b 100%)'
                            : 'linear-gradient(135deg,#eff6ff 0%,#ffffff 100%)',
                    border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(15,23,42,0.08)',
                    boxShadow: theme.palette.mode === 'dark' ? '0 10px 40px rgba(0,0,0,0.35)' : '0 10px 40px rgba(15,23,42,0.08)'
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: 320,
                        height: 320,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, rgba(37,99,235,0.18), rgba(147,51,234,0.15))',
                        top: -120,
                        right: -80,
                        filter: 'blur(40px)'
                    }}
                />

                {/* <Button
                    variant="outlined"
                    startIcon={<IconArrowLeft size={18} />}
                    onClick={() => history.goBack()}
                    sx={{
                        borderRadius: '12px',
                        textTransform: 'none'
                    }}
                >
                    Voltar
                </Button> */}

                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 2,
                        marginTop: 2
                    }}
                >
                    <Chip
                        icon={<IconUsers size={14} />}
                        label="Administração"
                        sx={{
                            mb: 2,
                            fontWeight: 700
                        }}
                    />

                    <Typography
                        variant="h1"
                        sx={{
                            fontWeight: 900,
                            fontSize: {
                                xs: '2rem',
                                md: '3rem'
                            },
                            letterSpacing: '-2px',
                            mb: 1,
                            background: 'linear-gradient(90deg,#2563eb,#9333ea)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        Usuários do Sistema
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                            maxWidth: 700,
                            lineHeight: 1.8,
                            mb: 4
                        }}
                    >
                        Gerencie usuários, permissões e acessos administrativos da plataforma.
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            flexWrap: 'wrap'
                        }}
                    >
                        <OutlinedInput
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Buscar usuário..."
                            startAdornment={
                                <InputAdornment position="start">
                                    <IconSearch size={18} />
                                </InputAdornment>
                            }
                            sx={{
                                flex: 1,
                                minWidth: 280,
                                height: 56,
                                borderRadius: '18px',
                                background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#fff'
                            }}
                        />

                        <Button
                            variant="contained"
                            startIcon={<IconPlus size={18} />}
                            onClick={handleOpenCreate}
                            sx={{
                                height: 56,
                                px: 3,
                                borderRadius: '18px',
                                textTransform: 'none',
                                fontWeight: 700,
                                background: 'linear-gradient(135deg,#2563eb,#9333ea)',
                                boxShadow: '0 10px 25px rgba(37,99,235,0.25)'
                            }}
                        >
                            Novo Usuário
                        </Button>
                    </Box>
                </Box>
            </Box>

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mb: 3,
                        borderRadius: '16px'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            {/* LIST */}

            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        py: 10
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {filteredUsers.map((user, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={user.id}>
                            <MotionCard
                                initial={{
                                    opacity: 0,
                                    y: 20
                                }}
                                animate={{
                                    opacity: 1,
                                    y: 0
                                }}
                                transition={{
                                    delay: index * 0.03
                                }}
                                whileHover={{
                                    y: -5
                                }}
                                sx={{
                                    borderRadius: '24px',
                                    overflow: 'hidden',
                                    height: '100%',
                                    border:
                                        theme.palette.mode === 'dark'
                                            ? '1px solid rgba(255,255,255,0.06)'
                                            : '1px solid rgba(15,23,42,0.06)',
                                    background: theme.palette.mode === 'dark' ? 'linear-gradient(180deg,#111827 0%,#0f172a 100%)' : '#fff',
                                    boxShadow:
                                        theme.palette.mode === 'dark' ? '0 10px 30px rgba(0,0,0,0.3)' : '0 10px 30px rgba(15,23,42,0.06)'
                                }}
                            >
                                <CardActionArea
                                    onClick={() => handleOpenEdit(user)}
                                    sx={{
                                        height: '100%'
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: 3
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                mb: 2
                                            }}
                                        >
                                            <Avatar
                                                src={getAvatarUrl(user.avatar_img)}
                                                sx={{
                                                    width: 60,
                                                    height: 60
                                                }}
                                            >
                                                {!user.avatar_img && user.first_name?.charAt(0)}
                                            </Avatar>

                                            {user.role === 'admin' && (
                                                <Chip
                                                    icon={<IconShield size={14} />}
                                                    label="Administrador"
                                                    size="small"
                                                    sx={{ fontWeight: 700 }}
                                                />
                                            )}
                                            {user.role === 'manager' && (
                                                <Chip
                                                    icon={<IconShield size={14} />}
                                                    label="Gerente"
                                                    size="small"
                                                    sx={{ fontWeight: 700 }}
                                                />
                                            )}
                                            {user.role === 'attendant' && (
                                                <Chip
                                                    icon={<IconShield size={14} />}
                                                    label="Atendente"
                                                    size="small"
                                                    sx={{ fontWeight: 700 }}
                                                />
                                            )}
                                        </Box>

                                        <Typography
                                            variant="h4"
                                            sx={{
                                                fontWeight: 800,
                                                mb: 1
                                            }}
                                        >
                                            {user.first_name} {user.last_name}
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                color: 'text.secondary'
                                            }}
                                        >
                                            <IconMail size={16} />

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {user.email}
                                            </Typography>
                                        </Box>

                                        <Divider
                                            sx={{
                                                my: 2
                                            }}
                                        />

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: 'text.secondary'
                                                }}
                                            >
                                                Clique para editar
                                            </Typography>

                                            <IconEdit size={18} />
                                        </Box>
                                    </CardContent>
                                </CardActionArea>
                            </MotionCard>
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* MODAL */}

            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: '24px'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontWeight: 800
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}
                    >
                        <IconUser size={22} />

                        {editingUser ? 'Editar Usuário' : 'Novo Usuário'}
                    </Box>

                    <IconButton onClick={() => setOpenModal(false)}>
                        <IconX size={18} />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2, borderRadius: '12px' }}>
                            {status.message}
                        </Alert>
                    )}

                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Nome"
                                value={form.first_name}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        first_name: e.target.value
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Sobrenome"
                                value={form.last_name}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        last_name: e.target.value
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={form.email}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        email: e.target.value
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                select
                                label="Permissão"
                                value={form.role}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        role: e.target.value
                                    })
                                }
                            >
                                {ROLE_OPTIONS.map((role) => (
                                    <MenuItem key={role.value} value={role.value}>
                                        {role.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {editingUser ? (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Nova senha (opcional)"
                                        value={form.password}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                password: e.target.value
                                            })
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        startIcon={<IconMail size={18} />}
                                        onClick={handleResetPassword}
                                        sx={{
                                            borderRadius: '12px',
                                            textTransform: 'none'
                                        }}
                                    >
                                        Resetar senha por e-mail
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xs={12}>
                                <Alert severity="info" sx={{ borderRadius: '12px' }}>
                                    Um e-mail será enviado para que o usuário defina sua própria senha.
                                </Alert>
                            </Grid>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Avatar
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Avatar
                                src={avatarPreview}
                                sx={{
                                    width: 72,
                                    height: 72
                                }}
                            />

                            <Box>
                                <Button variant="outlined" component="label">
                                    Selecionar imagem
                                    <input hidden type="file" accept="image/*" onChange={handleImageUpload} />
                                </Button>

                                {avatar && (
                                    <Button color="error" onClick={removeImage} sx={{ ml: 1 }}>
                                        Remover
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        justifyContent: 'space-between'
                    }}
                >
                    {editingUser ? (
                        <Button
                            color="error"
                            startIcon={<IconTrash size={18} />}
                            onClick={() => {
                                setOpenModal(false);

                                handleDelete(editingUser.id);
                            }}
                            sx={{
                                borderRadius: '12px',
                                textTransform: 'none'
                            }}
                        >
                            Excluir
                        </Button>
                    ) : (
                        <Box />
                    )}

                    <Button
                        variant="contained"
                        startIcon={<IconDeviceFloppy size={18} />}
                        onClick={handleSave}
                        sx={{
                            borderRadius: '14px',
                            px: 3,
                            textTransform: 'none',
                            fontWeight: 700,
                            background: 'linear-gradient(135deg,#2563eb,#9333ea)'
                        }}
                    >
                        Salvar Usuário
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SystemUsers;
